/**
 * Внимание!
 * Данный скрипт является базой проекта.
 * Его наличие обязательно на странице, т.к. отвечает за общий функционал.
 */
import("jquery-modal/jquery.modal").then((_) => {});

// замена номера телефона в хедере в зависимости от местонахождения
import("./components/geoPhone");

// reach goal
import("../../js/reachGoal").then((_) => {});

// telegram modal
import("./components/telegramModal").then((_) => {});

// jivo button
import("./components/jivoScript").then((_) => {});

// menu scripts
import("./components/menu").then((_) => {});

// Динамическая подгрузка недостающего меню
import("./components/dynamic-menu-loading").then((_) => {});

import("./components/hlinkHandler").then((_) => {});

// Фикс скролла по странице по нажатию на якорь
import("./components/anchorScroll").then((_) => {});

function nextTick(fn) {
    setTimeout(fn, 100);
}

window.nextTick = nextTick;

$(() => {
    // replace page images src with data-src, but skip .swiper-lazy
    $("img[data-src]")
        .not(".swiper-lazy")
        .each(function () {
            let img = $(this);
            img.attr("src", img.attr("data-src"));
            this.onload = function () {
                img.removeAttr("data-src");
            };
        });
});

// make button (scroll up) appearing and hiding while scroll
$(window).on("scroll", function () {
    const scrollUp = $(".scrollup");
    if ($(this).scrollTop() > 100) {
        if (scrollUp.css("display") === "none") {
            scrollUp.fadeIn("fast");
        }
    } else {
        if (scrollUp.css("display") === "block") {
            scrollUp.fadeOut();
        }
    }
});

window["loadPartial"] = (el, url, params = {}) => {
    if (!el.data("partialLoaded")) {
        console.log("partial not loaded yet.. loading");

        el.data("partialLoaded", true);

        $.get(url, params, (html) => {
            console.log("partial loaded");
            $(el).html(html);
        });
    }
};

/**
 * Клик по кнопке рейтинги - загрузка реакт прилоежния рейтингов
 */
window["activateRatings"] = () => {
    import("./components/ratings").then((lib) => {
        lib.default(document.querySelectorAll(".menu-ratings-widget"));
    });
};

/**
 * Показ модалки по нажатию кнопки "Заказать звонок"
 */
$(() => {
    $(".request-call-btn").on("click", function (e) {
        e.preventDefault();

        let button = $(this);

        if (button.attr("data-href") === undefined) {
            button.attr(
                "data-href",
                `${window.location.origin}/modal/request-call/`
            );
        }

        import("./components/openAjaxModal").then((module) => {
            module.default(button);
        });
    });
});

/*
 * Загрузка скриптов, вызываемых по клику на экране
 */
$(document).on("click", function (e) {
    let target = $(e.target);

    /**
     * Заменяет статичную кратинку/обложку на iframe ютуб плеер
     */
    if (target.hasClass("yt-iframe-replace")) {
        import("./components/ytReplaceIframe").then((module) => {
            module.ytReplaceIframe(target);
        });
    }

    /**
     * Заменяет статичную кратинку/обложку на iframe рутуб плеер
     */
    if (target.hasClass("rutube-iframe-replace")) {
        import("./components/rutubeReplaceIframe").then((module) => {
            module.rutubeReplaceIframe(target);
        });
    }
});

/**
 * Открытие модалки при клике на .ajax-modal
 * (Обработчик события при клике на элемент, который имеет селектор .ajax-modal)
 */
$(document).on("click", ".ajax-modal", function (e) {
    e.preventDefault();
    e.stopPropagation();

    import("./components/openAjaxModal").then((module) => {
        module.default($(this));
    });
});

/**
 * Обрабатывает нажатие на элемент "аккордион"
 */
$(document).on("click", ".accordion__title", function () {
    import("./components/accordion").then((module) => {
        module.handleAccordionClick($(this));
    });
});

/**
 * Нажатие на селектор
 */
$(() => {
    $(document).on("click", ".form__select", function () {
        import("./components/handleFormSelect").then((module) => {
            module.handleFormSelect($(this));
        });
    });
});
